import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { SanctuaryShell, sanctuaryLinks } from './SanctuaryShell';

function SanctuaryTerms() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <main className="main sanctuary-page-root">
      <SanctuaryShell>
        <article className="sanc-wrap sanc-legal">
          <Link className="sanc-back" to="/projects/sanctuary">
            ← Sanctuary home
          </Link>
          <h1 className="sanc-legal__title">Terms of Use</h1>
          <p className="sanc-legal__meta">
            Sanctuary · com.sahgal.sanctuaryy · Last updated: 14 July 2026
            <br />
            Operated by {sanctuaryLinks.business}
          </p>

          <h2>1. Agreement</h2>
          <p>
            By downloading, accessing, or using the Sanctuary Android app or related website,
            you agree to these Terms. If you do not agree, do not use Sanctuary.
          </p>

          <h2>2. The product</h2>
          <p>
            Sanctuary is a library / study-space management application for India. It offers
            Manager and Student experiences for seats, memberships, attendance, alerts, and
            payments where enabled by the library.
          </p>

          <h2>3. Accounts &amp; roles</h2>
          <ul>
            <li>
              <strong>Managers</strong> are responsible for accurate library and student data,
              complying with applicable law, and handling student relationships at their
              premises.
            </li>
            <li>
              <strong>Students</strong> must keep login credentials secure and use the app only
              for their membership at the registering library.
            </li>
            <li>You must provide accurate information and are responsible for activity under your account.</li>
          </ul>

          <h2>4. Payments</h2>
          <p>
            Online payments (where enabled) are processed via Razorpay. Student fees go to the
            library’s Razorpay / bank arrangement. Sanctuary does not hold student money as an
            aggregator. Separate commercial terms may apply to Sanctuary’s own Manager
            subscription or platform fees — see also our{' '}
            <Link to="/projects/sanctuary/refund">Refund Policy</Link>.
          </p>

          <h2>5. Acceptable use</h2>
          <ul>
            <li>Do not misuse the service, attempt unauthorized access, or disrupt systems.</li>
            <li>Do not upload unlawful, harmful, or infringing content.</li>
            <li>Do not use Sanctuary for purposes outside legitimate library operations.</li>
          </ul>

          <h2>6. Intellectual property</h2>
          <p>
            Sanctuary branding, software, and materials belong to {sanctuaryLinks.business} /
            Abhay Sahgal except where third-party licenses apply. You get a limited,
            non-exclusive right to use the app as provided.
          </p>

          <h2>7. Disclaimers &amp; liability</h2>
          <p>
            The service is provided “as is” to the extent permitted by law. We do not guarantee
            uninterrupted availability. We are not responsible for disputes between Managers and
            Students about seats, fees, or library policies. Nothing in these Terms limits
            rights that cannot be waived under Indian law.
          </p>

          <h2>8. Changes &amp; termination</h2>
          <p>
            We may update these Terms or the service. Continued use after changes means
            acceptance. We may suspend accounts that violate these Terms or pose risk to users
            or the platform.
          </p>

          <h2>9. Contact</h2>
          <p>
            {sanctuaryLinks.business}
            <br />
            <a href={`mailto:${sanctuaryLinks.email}`}>{sanctuaryLinks.email}</a>
            <br />
            <a href={sanctuaryLinks.phoneTel}>+91 {sanctuaryLinks.phone}</a>
            <br />
            {sanctuaryLinks.address}
          </p>
        </article>
      </SanctuaryShell>
    </main>
  );
}

export default SanctuaryTerms;
